// extracted by mini-css-extract-plugin
module.exports = {"H1":"Title_H1__1KN5C","H2":"Title_H2__2jwqt","H3":"Title_H3__2v3H_","light":"Title_light__1RbN6","dark":"Title_dark__akXyb"};